import { useState, type JSX } from "react";

/**
 * reader 向けナビゲーションメニュー。 固定 top-left 配置で play 中でも /search / /library へアクセス可能。
 */
export function ReaderNavMenu(): JSX.Element {
  const [open, setOpen] = useState(false);

  return (
    <div
      className="fixed z-40"
      style={{
        top: "calc(env(safe-area-inset-top) + 1rem)",
        left: "calc(env(safe-area-inset-left) + 1rem)",
      }}
    >
      <button
        type="button"
        aria-label="メニューを開く"
        aria-expanded={open}
        data-testid="reader-nav-menu-button"
        onClick={() => setOpen((v) => !v)}
        className="flex h-11 w-11 items-center justify-center rounded-full bg-reader-surface text-lg text-reader-secondary shadow-md backdrop-blur hover:bg-reader-border"
      >
        ☰
      </button>

      {open && (
        <>
          <div
            className="fixed inset-0 z-30"
            aria-hidden="true"
            onClick={() => setOpen(false)}
          />
          <nav
            role="menu"
            aria-label="ナビゲーション"
            data-testid="reader-nav-menu"
            className="absolute left-0 top-12 z-40 min-w-36 rounded-lg bg-reader-surface shadow-lg border border-reader-border overflow-hidden"
          >
            <a
              href="/search"
              role="menuitem"
              className="flex items-center gap-2 px-4 py-3 text-sm text-reader-primary hover:bg-reader-border"
              onClick={() => setOpen(false)}
            >
              🔍 シナリオを探す
            </a>
            <a
              href="/library"
              role="menuitem"
              className="flex items-center gap-2 px-4 py-3 text-sm text-reader-primary hover:bg-reader-border"
              onClick={() => setOpen(false)}
            >
              📚 ライブラリ
            </a>
            <a
              href="/notifications"
              role="menuitem"
              className="flex items-center gap-2 px-4 py-3 text-sm text-reader-primary hover:bg-reader-border"
              onClick={() => setOpen(false)}
            >
              🔔 通知
            </a>
          </nav>
        </>
      )}
    </div>
  );
}
